import DepsService from 'services/dependencies';

const CONTEXT = 'theme';

export const saveTheme = async (theme) => {
  const url = DepsService.rest.theme.url;

  return await DepsService.restSrv.update(CONTEXT, url, theme);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/theme.api.js